export default __webpack_public_path__ + "static/media/trivia.7e9181d3.png";